import type { RivalRequest } from '../types'
import './RivalChallengeBanner.css'

interface RivalChallengeBannerProps {
  request: RivalRequest
  onAccept: (requestId: string) => void
  onDecline: (requestId: string) => void
  onDismiss: (requestId: string) => void
}

// Persistent + actionable, unlike Toast/InlineToast (both auto-dismiss after 7000ms with no
// action slot) — a challenge needs to stay on screen until the recipient responds or
// explicitly dismisses it.
function RivalChallengeBanner({ request, onAccept, onDecline, onDismiss }: RivalChallengeBannerProps) {
  return (
    <div className="rival-challenge-banner" role="alert">
      <p className="rival-challenge-banner__message">
        <strong>{request.fromDisplayName}</strong> has challenged you to a Rivalry.
      </p>
      <div className="rival-challenge-banner__actions">
        <button
          type="button"
          className="rival-challenge-banner__accept"
          onClick={() => onAccept(request.id)}
        >
          Accept
        </button>
        <button
          type="button"
          className="rival-challenge-banner__decline"
          onClick={() => onDecline(request.id)}
        >
          Decline
        </button>
        <button
          type="button"
          className="rival-challenge-banner__dismiss"
          onClick={() => onDismiss(request.id)}
          aria-label="Dismiss"
        >
          ✕
        </button>
      </div>
    </div>
  )
}

export default RivalChallengeBanner
